import Cookies from 'universal-cookie';

export type AuthCookieOptions = {
  path: string;
  domain?: string;
  secure?: boolean;
  sameSite?: 'lax' | 'strict' | 'none';
};

export const getRootCwebCookieDomain = (): string | undefined => {
  // For local/localhost/IP we must NOT set domain (.c-web.dk would fail)
  const stage = process.env.REACT_APP_STAGE;
  if (stage === 'local' || stage === 'local ') return undefined;

  const host = window.location.hostname || '';
  if (host === 'c-web.dk' || host.endsWith('.c-web.dk')) return '.c-web.dk';

  return undefined;
};

export const getAuthCookieOptions = (): AuthCookieOptions => {
  const domain = getRootCwebCookieDomain();
  const isHttps = window.location.protocol === 'https:';

  const options: AuthCookieOptions = {
    path: '/',
    sameSite: 'lax',
  };

  if (domain) options.domain = domain;
  if (isHttps) options.secure = true;

  return options;
};

export const getAuthCookie = (cookieName: string, cookies = new Cookies()) => {
  return cookies.get(cookieName);
};

export const setAuthCookie = (
  cookieName: string,
  token: string,
  cookies = new Cookies()
) => {
  cookies.set(cookieName, token, getAuthCookieOptions());
};

export const removeAuthCookie = (
  cookieName: string,
  cookies = new Cookies()
) => {
  // remove host-only cookie
  cookies.remove(cookieName, { path: '/' });

  // remove root-domain cookie (if applicable)
  const domain = getRootCwebCookieDomain();
  if (domain) cookies.remove(cookieName, { path: '/', domain });
};
